import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import lPrompt from '@/components/l-prompt'
import lLoading from '@/components/l-loading'
import lToast from '@/components/l-toast'
import '@/utils/flexible'
import '@/utils/log'

Vue.use(lPrompt)
Vue.use(lLoading)
Vue.use(lToast)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
